import { NgModule } from '@angular/core';

import { modules, entryComponents } from 'extensions/render-components';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { IdtComponentsService } from './idt-components.service';


export const renderComponents = [
  ...entryComponents
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    ...modules
  ],
  providers: [
    IdtComponentsService
  ]
})
export class IdtComponentsRenderModule {}
